import store from '@/store';
import _ from 'lodash';
import moment from 'moment';

const configFile = require(process.env.VUE_APP_CONFIG);
const config = configFile.config;

export default {
  openExternalMap(lat, lon, address) {
    // If it's an iPhone..
    if (
      navigator.platform.indexOf('iPhone') !== -1 ||
      navigator.platform.indexOf('iPod') !== -1 ||
      navigator.platform.indexOf('iPad') !== -1 ||
      navigator.platform.indexOf('Mac') !== -1
    ) {
      window.open(
        `https://maps.apple.com/?sll=${lat},${lon}&t=r&z=14&daddr=${address}`,
        '_self'
      );
    } else {
      window.open(`https://www.google.com/maps/dir//${lat},${lon}`);
    }
  },

  downloadApp() {
    if (this.isApple()) {
      return config.SITE[store.state.countrySelected.code].APP.APPLE;
    } else {
      return config.SITE[store.state.countrySelected.code].APP.ANDROID;
    }
  },

  isApple() {
    if (
      navigator.platform.indexOf('iPhone') !== -1 ||
      navigator.platform.indexOf('iPod') !== -1 ||
      navigator.platform.indexOf('iPad') !== -1 ||
      navigator.platform.indexOf('Mac') !== -1
    ) {
      return true;
    } else {
      return false;
    }
  },

  isSpain() {
    return store.state.countrySelected.code === 'ES';
  },

  isProduction() {
    return process.env.NODE_ENV === 'production';
  },

  isChile() {
    return store.state.countrySelected.code === 'CL';
  },

  getParkingImageSize(breakpoint, thumbnail) {
    if (thumbnail) {
      switch (breakpoint) {
        case 'xs': // < 600px
          return 'w=44';
        case 'sm': // 600px > < 960px
          return 'w=150';
        case 'md': // 960px > < 1264
          return 'w=300';
        case 'lg': // 1264 > < 1904px
          return 'w=300';
        case 'xl': // > 1904px
          return 'w=600';
      }
    } else {
      switch (breakpoint) {
        case 'xs': // < 600px
          return 'w=300';
        case 'sm': // 600px > < 960px
          return 'w=600';
        case 'md': // 960px > < 1264
          return 'w=600';
        case 'lg': // 1264 > < 1904px
          // TODO: change it when the lambda provides more sizes
          return 'w=600';
        // return 'original=true';
        case 'xl': // > 1904px
          // TODO: change it when the lambda provides more sizes
          return 'w=600';
        // return 'original=true';
      }
    }
  },

  getMapImageSize(breakpoint) {
    switch (breakpoint) {
      case 'xs': // < 600px
        return 'w=600&h=450';
      case 'sm': // 600px > < 960px
        return 'w=1000&h=750';
      case 'md': // 960px > < 1264
        return 'w=1200&h=900';
      case 'lg': // 1264 > < 1904px
        return 'w=1900&h=1425';
      case 'xl': // > 1904px
        return 'w=4000&h=3000';
    }
  },

  getSharedImage(image) {
    const imageParts = _.split(image, '.');
    const last = _.last(imageParts);
    const newLast = `_high.${last}`;
    return _.chain(imageParts)
      .dropRight()
      .join('.')
      .concat(newLast)
      .join('')
      .value();
    // return image + '?w=600';
  },

  getSharedLogo() {
    return `${window.location.protocol}//${window.location.host}/image/public/share/logo.jpg`;
  },

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  },

  getMomentTimezone(date, timezone) {
    let result = moment(date);
    if (typeof timezone !== 'undefined' && timezone !== null) {
      result = result.tz(timezone);
    }
    return result;
  },
};
